import type { Article } from "./types";

/**
 * Describes event-bound plans and the Trash (JUB-157). Published once that
 * behaviour was live: only legacy, never-applied purchases are unassigned, and
 * the Trash keeps an event (and its plan) restorable for 30 days.
 */
export const onePlanPerEvent: Article = {
  slug: "one-plan-per-event",
  published: true,
  publishedAt: "2026-10-06",
  updatedAt: "2026-10-06",
  title: {
    ro: "Un pachet pentru fiecare eveniment și coșul de gunoi",
    en: "One plan per event, and the Trash",
  },
  summary: {
    ro: "Cum se leagă un pachet de un eveniment, ce se întâmplă cu pachetul când muți evenimentul în coș și cum îl restaurezi.",
    en: "How a plan is tied to an event, what happens to the plan when you move the event to the Trash, and how to restore it.",
  },
  body: {
    ro: [
      { t: "h2", text: "O plată, un eveniment" },
      { t: "p", text: "Un pachet se cumpără pentru un singur eveniment. Creează întâi evenimentul, apoi alege pachetul pentru el. Pachetul rămâne asociat acelui eveniment și nu poate fi mutat pe alt eveniment." },
      { t: "p", text: "Pachetele deja aplicate unui eveniment rămân la acel eveniment. La „Pachete neatribuite” apar doar pachetele cumpărate înainte de această schimbare și neaplicate niciodată unui eveniment. Un astfel de pachet îl poți aplica o singură dată, unuia dintre evenimentele tale, iar după aplicare nu mai poate fi mutat." },
      { t: "h2", text: "Coșul de gunoi" },
      { t: "p", text: "Un eveniment pe care îl muți în coș („Mută în coș”) poate fi restaurat timp de 30 de zile din secțiunea „Coș de gunoi” a listei de evenimente. Pachetul plătit rămâne asociat evenimentului și revine odată cu el când îl restaurezi." },
      { t: "p", text: "Un eveniment aflat în coș nu poate primi un pachet nou. Restaurează-l mai întâi." },
      { t: "h2", text: "Ștergerea definitivă" },
      { t: "p", text: "După cele 30 de zile, evenimentul se șterge definitiv. Îl poți șterge definitiv și mai devreme, din coș, cu „Șterge definitiv”; pentru confirmare scrii numele evenimentului." },
      { t: "p", text: "La ștergerea definitivă, invitații, cadourile și fotografiile evenimentului se șterg și nu mai pot fi recuperate. Pachetul rămâne consumat și nu poate fi folosit pentru alt eveniment." },
    ],
    en: [
      { t: "h2", text: "One payment, one event" },
      { t: "p", text: "A plan is bought for one event. Create the event first, then choose the plan for it. The plan stays with that event and cannot be moved to another event." },
      { t: "p", text: "Plans already applied to an event stay with that event. “Unassigned plans” only lists plans bought before this change and never applied to an event. You can apply such a plan once, to one of your events, and after that it cannot be moved." },
      { t: "h2", text: "The Trash" },
      { t: "p", text: "An event you move to the Trash (“Move to Trash”) can be restored for 30 days from the “Trash” section of the events list. The paid plan stays with the event and comes back with it when you restore it." },
      { t: "p", text: "An event in the Trash cannot get a new plan. Restore it first." },
      { t: "h2", text: "Permanent deletion" },
      { t: "p", text: "After the 30 days, the event is deleted permanently. You can also delete it permanently earlier from the Trash with “Delete permanently”; to confirm, you type the event name." },
      { t: "p", text: "On permanent deletion, the event's guests, gifts and photos are deleted and cannot be recovered. The plan stays used and cannot be applied to another event." },
    ],
  },
};
